<template>
	<pageWithNav>
		<innerPage :innerTopNav="true">
			<div slot="page">
				<div style="display: flex; flex-direction: row">
					<div>
						<h1>Integrations</h1>
						<h3 style="font-weight: bold; margin-bottom: 0px">
							Create powerful workflows with
							{{ availableIntegrations.length ? availableIntegrations.length : "300+" }} integrations
						</h3>
					</div>
				</div>
				<el-divider class="compressedDivider"></el-divider>
				<el-container>
					<el-aside style="width: 250px">
						<el-input
							clearable
							placeholder="Search by integration name"
							prefix-icon="el-icon-search"
							v-model="integrationSearchQuery"
							style="margin-bottom: 20px; width: 95%; margin-top: 24px"
						>
						</el-input>
						<sideList @event="sideListEvent" :multiSelect="true" :options="filterOptions" />
					</el-aside>
					<el-container>
						<el-main style="padding: 0px; overflow: hidden">
							<integrationsItemList
								:filter="filters"
								:searchQuery="integrationSearchQuery"
								:list="availableIntegrations"
							/>
						</el-main>
					</el-container>
				</el-container>
			</div>
		</innerPage>
	</pageWithNav>
</template>

<script>
import pageWithNav from "../components/pageWithNav.vue";
import innerPage from "../components/innerPage.vue";
import sideList from "../components/sideList.vue";
import integrationsItemList from "../components/integrationsItemList.vue";
export default {
	components: {
		pageWithNav,
		innerPage,
		sideList,
		integrationsItemList,
	},
	data() {
		return {
			integrationSearchQuery: "",
			availableIntegrations: [],
			filters: [],
			filterOptions: [
				{ name: "AI", checked: false, alias: "AI" },
				{ name: "Analytics", checked: false, alias: "Analytics" },
				{ name: "Data & Storage", checked: false, alias: "Data & Storage" },
				{ name: "Development & Cloud", checked: false, alias: "Development & Cloud" },
				{ name: "Ecommerce", checked: false, alias: "Ecommerce" },
				{ name: "Finance & Accounting", checked: false, alias: "Finance & Accounting" },
				{ name: "IOT", checked: false, alias: "IOT" },
				{ name: "Marketing", checked: false, alias: "Marketing" },
				{ name: "Messaging", checked: false, alias: "Messaging" },
				{ name: "Sales & CRM", checked: false, alias: "Sales & CRM" },
				{ name: "Social", checked: false, alias: "Social" },
				{ name: "System Specific", checked: false, alias: "System Specific" },
			],
		};
	},
	async mounted() {
		this.returnAllNodes();
		//Store large static list in central store, only fetch if list is not present
	},
	methods: {
		sideListEvent(filters) {
			this.filters = filters;
		},
		async returnAllNodes() {
			const result = await this.httpHelper("RUNTIME", "GET", "nodes/returnAllNodeDefinitions", {});
			if (!result?.error) {
				this.availableIntegrations = Object.freeze(result.response);
			}
		},
	},
};
</script>

<style scoped>
.compressedDivider {
	margin-bottom: 0px;
}
</style>
